import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=9318dd6e&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=9318dd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9318dd6e",
  null
  
)

export default component.exports